export default "__VITE_ASSET__BchcqTqZ__"